/*
 * card-swatch-swap.js
 * Click (or Enter/Space) a product-card colour swatch to swap the card's main image
 * to that colour's variant image. Vanilla JS, event-delegated, lazy (only fires on
 * user interaction), and self-guarded so it can be included from a snippet rendered
 * many times per page without re-binding.
 *
 * Markup contract (see snippets/product-card-swatches.liquid + custom-product-card.liquid):
 *   .custom-card                         — card root
 *   .custom-card__main-image             — the <img> to swap
 *   .swatch--swappable[data-swatch-image]— a swatch carrying its variant image URL
 */
(function () {
  if (window.__cgkCardSwatchSwapInit) return;
  window.__cgkCardSwatchSwapInit = true;

  var SWATCH_SELECTOR = '.swatch--swappable[data-swatch-image]';

  function swap(swatch) {
    var src = swatch.getAttribute('data-swatch-image');
    if (!src) return;

    var card = swatch.closest('.custom-card');
    if (!card) return;

    var img = card.querySelector('.custom-card__main-image');
    if (!img) return;

    // No-op if already showing this image (prevents flicker / redundant requests).
    if (img.getAttribute('src') === src) return;

    // Same element, same box -> no layout shift. Drop srcset so the new src wins.
    img.setAttribute('src', src);
    img.removeAttribute('srcset');

    // Reflect the active colour within this card only.
    var actives = card.querySelectorAll(SWATCH_SELECTOR + '.is-active');
    for (var i = 0; i < actives.length; i++) {
      actives[i].classList.remove('is-active');
    }
    swatch.classList.add('is-active');
  }

  function handleActivate(e) {
    var swatch = e.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;
    // The card has a full-cover <a> overlay; stop it from navigating on a swatch tap.
    e.preventDefault();
    e.stopPropagation();
    swap(swatch);
  }

  document.addEventListener('click', handleActivate);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (!e.target.closest || !e.target.closest(SWATCH_SELECTOR)) return;
    handleActivate(e);
  });
})();
